import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import HotSwapSummary from '../how-swap-summary'
import HotSwapDatePicker from '../hot-swap-date-picker'
import { useQuery } from 'react-query'
import { getHotswapWeeksAvailabilityByLocationIds } from '../../api/hotswaps-api'

export default function ScheduleShippingStep({
    selectedHotSwapLocations,
    setScheduledDate
}) {
    const classes = useStyles()

    const onDateChange = value => {
        setScheduledDate(value)
    }

    const locations = useMemo(() => {
        if (selectedHotSwapLocations) {
            return selectedHotSwapLocations
                .map(location => location.id)
                .join(',')
        }

        return ''
    }, [data])

    const { data } = useQuery([locations], () =>
        getHotswapWeeksAvailabilityByLocationIds(locations)
    )

    return (
        <div className={classes.container}>
            <HotSwapSummary
                selectedHotSwapLocations={selectedHotSwapLocations}
            />

            {data && (
                <HotSwapDatePicker
                    onDateChange={onDateChange}
                    disableWeeks={data}
                />
            )}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '75px'
    }
}))
